import owd from 'owd/owd';
import _ from 'underscore';

export default class Dictionary extends owd.Component {
	init() {
        this.inputExpression = this.$element.find('#expression');
        this.radioCategory = this.$element.find('[name="category"]');
        
        this.cats = $('.dictionary-definitions');
        this.expressions = this.cats.find('[data-expression]');
        this.error = $('.dictionary-error');
        
		this.bind();
	}
    
    showResults(i, el) {
        el = $(el);

        el.removeClass('is-visible');
        el.parent().removeClass('is-visible');
        this.error.removeClass('no-results');

        if(el.data('expression').indexOf(this.inputExpression.val().toLowerCase()) !== -1) {
            el.addClass('is-visible');
            el.parent().addClass('is-visible');
        } else {
            this.error.addClass('no-results');
        }
    }
    
    searchByInput() {
        if(this.inputExpression.val() !== '') {
            this.expressions.each(this.showResults.bind(this));
        } else {
            this.showAllRows();
        }
    }
    
    showAllCategories() {
        this.cats.addClass('is-visible');
        this.error.removeClass('no-results');
    }
    
    showAllRows() {
        this.expressions.addClass('is-visible');
        this.expressions.parent().addClass('is-visible');
        this.error.removeClass('no-results');
    }

	bind() {
        this.on('submit', (e) => {
            e.preventDefault();
            
            this.searchByInput();
        });
        
        this.on('input', this.inputExpression, _.throttle((e) => {
            this.searchByInput();
        }, 500));
        
        this.on('change', this.radioCategory, (e) => {
            const currentTarget = $(e.currentTarget);
            const cat = currentTarget.data('cat');

            this.showAllRows();

            this.cats.each((i, el) => {
                el = $(el);

                el.removeClass('is-visible');

                if(cat.indexOf(el.data('category')) !== -1) {
                    el.addClass('is-visible');
                }
            });

            if(cat === 'none') {
                this.showAllCategories();
            }
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('dictionary', {
	component: Dictionary
});
